// extracted by mini-css-extract-plugin
export default {"navControls":"f_g","navControls_closed":"f_h"};